import React from 'react';
import { Formik, Form } from 'formik';
import { Container, Grid } from '@material-ui/core';
import BoxWrapper from 'components/atoms/BoxWrapper';
import * as Yup from 'yup';
import Button from 'components/atoms/Button/Button';
import FormControlInput from 'components/molecules/FormControlInput';
import FormControlSelect from 'components/molecules/FormControlSelect';
import ageArray from 'utils/GenerateYearsList';
import { isDisabled } from 'utils/buttonFormIsDisabled';
import { formatToUppercase } from '../../../utils/MaskFormatPostcode';

const stepThreeValidationSchema = Yup.object().shape({
    birth_date: Yup.string().required('Select your birth date!'),
    // postcode: Yup.string()
    //     .required('Enter your postcode!')
    //     .matches(
    //         /^(([A-Z][0-9]{1,2})|(([A-Z][A-HJ-Y][0-9]{1,2})|(([A-Z][0-9][A-Z])|([A-Z][A-HJ-Y][0-9]?[A-Z])))) [0-9][A-Z]{2}$/,
    //         {
    //             message: 'Please enter your full postcode.',
    //         },
    //     ),
    postcode: Yup.string()
        .min(4, 'Postcode must be at least 4 characters long.')
        .required('Enter your postcode!')
        .matches(/^[A-Za-z0-9 _]*[A-Za-z0-9][A-Za-z0-9 _]*$/, { message: 'Postcode can only use upper and lower case letters, numbers and spaces.' })
});

const StepThree = ({ setValuesToFormData, nextStep }) => {

    return (
        <Container>
            <BoxWrapper mt="50">
                <Grid container justify="center">
                    <Grid item xs={12} md={4}>
                        <Formik
                            initialValues={{
                                birth_date: '',
                                postcode: '',
                            }}
                            validationSchema={stepThreeValidationSchema}
                            onSubmit={(values) => {
                                setValuesToFormData(values);
                                nextStep('stepFour');
                            }}
                        >
                            {({ values, handleChange, handleBlur, isValid }) => (
                                <Form>
                                    <BoxWrapper mb="50" justifyContent="flex-start">
                                        <FormControlSelect
                                            value={values.birth_date}
                                            handleChange={handleChange}
                                            handleBlur={handleBlur}
                                            name="birth_date"
                                            label="The year of your birth"
                                            instruction="We don't need to know your exact birthday, but it's helpful to know what year you were born."
                                            options={ageArray}
                                        />
                                    </BoxWrapper>
                                    <BoxWrapper mb="50" justifyContent="flex-start">
                                        <FormControlInput
                                            type="text"
                                            label="Your full postcode"
                                            instruction="We use this to understand trends in your area"
                                            value={values.postcode}
                                            handleChange={(e) => formatToUppercase(handleChange, e)}
                                            handleBlur={handleBlur}
                                            name="postcode"
                                            color="secondary"
                                        />
                                    </BoxWrapper>

                                    <BoxWrapper>
                                        <Button
                                            variant="contained"
                                            color="primary"
                                            mt="20"
                                            width="50"
                                            type="submit"
                                            disabled={isDisabled(values, isValid)}
                                        >
                                            Continue
                                        </Button>
                                    </BoxWrapper>
                                </Form>
                            )}
                        </Formik>
                    </Grid>
                </Grid>
            </BoxWrapper>
        </Container>
    );
};

export default StepThree;
